import { Button, HStack } from '@chakra-ui/react'

interface Props {
  onClick: () => void
  values: { id: string; name: string }[]
  selected: string
}

const LabelsToggle = ({ onClick, values, selected }: Props) => {
  return (
    <HStack bgColor="#FFFFFF14" borderRadius="10px" h="32px" px={1} spacing="4px">
      {values.map((item) => (
        <Button
          key={item.id}
          onClick={onClick}
          color={selected === item.id ? 'text.secondary' : 'text.primary'}
          bgColor={selected === item.id ? 'rgba(255, 255, 255, 0.32)' : 'transparent'}
          boxShadow={selected === item.id ? 'inset 0px 1px 0px rgba(255, 255, 255, 0.08)' : 'none'}
          borderRadius="6px"
          width={values.length > 1 ? '50%' : '100%'}
          h="24px"
          fontSize="12px"
          _hover={{ textDecoration: 'none' }}
          _active={{ textDecoration: 'none' }}
        >
          {item.name}
        </Button>
      ))}
    </HStack>
  )
}

export default LabelsToggle
